import { Box } from '@chakra-ui/react'
import { useCallback, useEffect } from 'react'

import { useUser } from '@/client/context/user'
import useOneTimeAcknowledgement from '@/client/hooks/useOneTimeAcknowledgement'
import hasUserRole from '@/client/services/user/hasUserRole'

import ShwLink from '@/components/ShwLink'
import { useToaster } from '@/components/Toast/useToaster'

const COMMUNITY_SURVEY_ACK_KEY = 'dashboard:community-survey-04-10-26'
const SURVEY_END_DATE = new Date('2026-04-30T23:59:00-04:00')
const SURVEY_URL = 'https://form.typeform.com/to/c5a3dF5K?utm_source=toast'

let hasPresentedSurveyToast = false

export default function CommunitySurveyToast() {
  const user = useUser()
  const toast = useToaster()
  const { acknowledgedAt, onAcknowledgement } = useOneTimeAcknowledgement(
    COMMUNITY_SURVEY_ACK_KEY,
    { disableRefresh: true }
  )

  const shouldPresentToast =
    acknowledgedAt == null && new Date() < SURVEY_END_DATE && hasUserRole(user, 'user:approved')

  const presentToast = useCallback(() => {
    if (hasPresentedSurveyToast) {
      return
    }
    hasPresentedSurveyToast = true

    toast({
      description: (
        <Box>
          Help shape Schoolhouse&apos;s future — take our{' '}
          <ShwLink href={SURVEY_URL}>Spring community survey</ShwLink>!
        </Box>
      ),
      status: 'info',
      duration: null,
      onCloseComplete: onAcknowledgement,
    })
  }, [toast, onAcknowledgement])

  useEffect(() => {
    if (shouldPresentToast) {
      // We add a delay so the toast container has time to mount
      setTimeout(presentToast, 1000)
    }
    // Intentionally only triggering this once, regardless of dependencies
    // oxlint-ignore-next-line react/exhaustive-deps
  }, [])

  return null
}
